import { InjectionToken } from '@angular/core';

import { AdvertiserEdit, AdvertiserEntitiesResponse } from '@rp/shared/models';
import { Observable } from 'rxjs';

export interface AdvertiserEntitiesProvider {
  getAdvertiserEntities(params: string): Observable<AdvertiserEntitiesResponse>;
  getAdvertiserEntity(id: number): Observable<AdvertiserEdit>;
}

export const ADVERTISER_ENTITIES_PROVIDER_TOKEN = new InjectionToken<AdvertiserEntitiesProvider>(
  'AdvertiserEntitiesProvider',
);
